import React      from 'react';
import { Header } from "semantic-ui-react";

import { DecisionPointDefinition, DecisionPointDialog, DecisionPointDialogProps } from "@src/views/components/modals/DecisionPointDialog";
import { HelpAndSupportStatement }                                                from "@src/views/components/util/messaging/HelpAndSupportStatement";
import { CHARACTER_VISUAL_AID }                                                   from "@src/views/components/product/CorvalCharacterVisualAid";


export enum CorvalAssistantBasicHelpDecisionPointTypes {
    BASIC_ASSISTANCE         = 1,
    PAGE_SPECIFIC_ASSISTANCE = 2,
}

interface CorvalAssistantBasicHelpDecisionPointDialogProps extends Omit<DecisionPointDialogProps<CorvalAssistantBasicHelpDecisionPointTypes>, 'dialogTitle' | 'decisionOptions'> {}

const CorvalAssistantBasicHelpDecisionPointDialogDefaultProps = {} satisfies Partial<CorvalAssistantBasicHelpDecisionPointDialogProps>

function CorvalAssistantBasicHelpDecisionPointDialog( p: CorvalAssistantBasicHelpDecisionPointDialogProps ){

    const props = { ...CorvalAssistantBasicHelpDecisionPointDialogDefaultProps, ...p };

    // const { ...props } = _props;

    const CorvalAssistantBasicHelpGuidanceOptions = new Map<CorvalAssistantBasicHelpDecisionPointTypes, DecisionPointDefinition>( [

        [ CorvalAssistantBasicHelpDecisionPointTypes.PAGE_SPECIFIC_ASSISTANCE, {
            title:       'Information on this page',
            description: `Get specific information about what you're looking at.`,
            icon:        { name: 'compass' },
            details:     (
                             <>
                                 <Header size={ 'small' }>Corval Assistant Search</Header>
                                 <p>Corval's assistant can help find things about this page and what you are experiencing.</p>
                                 <p>If you want to talk to someone instead,<br /><HelpAndSupportStatement withPreAmble={ false }
                                                                               withPostAmble={ false }
                                                                               withInlineCasing={ true }
                                                                               useIntercomMessaging={ true }
                                                                               contactName={ '' }/>!
                                 </p>
                             </>
                         ),
            actionLabel: 'View Page Information',
            active:      true,
            available:   true,
        } ],
        [ CorvalAssistantBasicHelpDecisionPointTypes.BASIC_ASSISTANCE, {
            title:       'Help Me!',
            description: 'Contact support for assistance.',
            icon:        { name: 'life ring' },
            details:     (
                             <>
                                 <Header size={ 'small' }>We're Here to Help!</Header>
                                 <p>Planning commercialization can be tough, especially when coordinating resources and timing. Corval can help you make the best decisions for your business.<br/>
                                     <HelpAndSupportStatement withPreAmble={ false }
                                                              withPostAmble={ false }
                                                              useIntercomMessaging={ true }
                                                              contactName={ '' }/>!
                                 </p>
                             </>
                         ),
            actionLabel: null,
            active:      true,
            available:   true,
        } ]
    ] );

    return (
        <DecisionPointDialog<CorvalAssistantBasicHelpDecisionPointTypes>
            { ...props }
            contentGridColumnWidth={ `35%` }
            dialogTitle={ `Corval Assistant` }
            decisionOptions={ CorvalAssistantBasicHelpGuidanceOptions }
        />
    );
}

export {
    CorvalAssistantBasicHelpDecisionPointDialog,
    CorvalAssistantBasicHelpDecisionPointDialogDefaultProps,
    type CorvalAssistantBasicHelpDecisionPointDialogProps,
};
